import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Lightweight per-page document metadata + scroll reset. No extra dependency.
export const Seo = ({ title, description, path, noindex = false }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const full = title ? `${title}` : "Arc & Hollow";
    document.title = full;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", full);
    setMeta("property", "og:type", "website");
    // Always set robots so client-side navigation resets it correctly between pages.
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    const canonical = `https://arcandhollow.co.uk${path || pathname}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [title, description, path, pathname, noindex]);

  return null;
};
